import React from "react";
import { Box, Button, Link, Typography } from "@mui/material";
import BaseModal from "./BaseModal";
import AuthModalSwitcher from "../AuthModalSwitcher";

const KioskRedirectModal = ({ handleClose, modalValue, isUser, isMobile }) => {
  const [modal, setModal] = React.useState(null);

  const { open, type } = modalValue;

  const buttonText = type === "logo" ? "Go to Main Website" : "Go to Saved Designs";

  const handleOk = () => {
    handleClose();
    switch (type) {
      case "logo":
        window.location.href = "https://supermixstudio.com/";
        break;
      case "design":
        window.location.href = "https://supermixstudio.com/account";
        break;
      default:
        return null;
    }
  };

  const handleCloseModal = (event) => {
    setModal(null);
  };

  const handleSignIn = () => {
    handleClose();
    setModal({ type: "SIGN_IN" });
  };
  const handleSignUp = () => {
    handleClose();
    setModal({ type: "SIGN_UP" });
  };

  return (
    <>
      {open && (
        <BaseModal headline="Save Your Progress" onClose={handleClose} gradient={true}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Typography sx={{ width: "100%" }} align="center">
              {!isUser && (
                <>
                  <Link onClick={handleSignIn}>Sign In</Link> or{" "}
                  <Link onClick={handleSignUp}>Sign Up</Link> to save your design.{" "}
                </>
              )}
              You will lose your progress if you return to the homepage without saving.
            </Typography>
            <Button
              variant="contained"
              sx={{
                width: "100%",
                maxWidth: "280px",
              }}
              onClick={handleOk}
            >
              {buttonText}
            </Button>
          </Box>
        </BaseModal>
      )}

      <AuthModalSwitcher
        onClose={handleCloseModal}
        setModal={setModal}
        modal={modal}
        isMobile={isMobile}
      />
    </>
  );
};

export default KioskRedirectModal;
